export const MIN_AGE = 17;
export const MAX_AGE = 25;

export const MIN_INCOME = 0;
export const MAX_INCOME = 100_000_000;

export const MIN_LOAN_AMOUNT = 500_000;
export const MAX_LOAN_AMOUNT = 4_000_000;

export const MIN_MATURITY_MONTHS = 12;
export const MAX_MATURITY_MONTHS = 120;

export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "Szeretném szakértő segítségét kérni a munkáshitel igénylésével kapcsolatban.",
		value: true,
	},
	{
		label: "Csak kiváncsiskodtam.",
		value: false,
	},
];
